module.exports = __webpack_public_path__ + "img/lfcs.d1074325.png";